import React, { forwardRef  } from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const CustomTextArea = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#26a69a', 
    },
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#26a69a',
    },
  },   

  '& .MuiInputBase-input.Mui-disabled': {
    color: 'rgba(0, 0, 0, 0.87)',
    WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
  },
});

const MuiTextArea = forwardRef(({label, value, onChange = ()=>{}, rows = 4, ...props}) => {

  return (
    <CustomTextArea
      label={label}
      value={value}
      onChange={(e)=>onChange(e.target.value)}
      variant="outlined"
      multiline
      rows={rows}
      fullWidth
      {...props}
    />
  );
});

export default MuiTextArea;